import { Navigate, useLocation } from 'react-router-dom';
import { WORKSPACE_CANVAS_MODES } from '@/components/workspace/workspaceMode';

const EtsyIntegrationPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('canvas', WORKSPACE_CANVAS_MODES.etsySetup);

  return <Navigate to={`/studio?${searchParams.toString()}`} replace />;
};

export default EtsyIntegrationPage;
